import "./usercredit.scss"

interface IUserCredit {
    credit: string
}

const UserCredit = ({credit}: IUserCredit) => {
    return (
        <div className="User-Credit">
            اعتبار شما :
            &nbsp;&nbsp;<span className="User-Credit-Amount">{credit}</span>
        </div>
    );
}

export default UserCredit;